export default __webpack_public_path__ + "static/media/3.96d6fb90.jpg";